import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, ShieldCheck, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 px-4 bg-brand-dark text-white border-b-8 border-brand-accent relative overflow-hidden" data-id="element-51">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-52">
        <p className="text-sm sm:text-base font-black text-brand-gold uppercase tracking-widest mb-4" data-id="element-53">
          UN'ULTIMA OCCASIONE
        </p>

        <h2 className="text-3xl sm:text-4xl md:text-5xl font-black mb-6 tracking-tight uppercase leading-tight" data-id="element-54">
          I tuoi allievi meritano molto più di sessioni improvvisate.
        </h2>

        <p className="text-base sm:text-lg font-medium text-white/90 mb-10 leading-relaxed max-w-3xl mx-auto" data-id="element-55">
          Smetti di passare ore a creare sequenze ogni settimana. Smetti di
          dubitare delle tue decisioni di programmazione. Smetti di chiederti se
          i tuoi allievi stanno progredendo abbastanza velocemente. Offri a ogni
          allievo un'esperienza di yoga strutturata, professionale e orientata
          ai risultati. Regalati il sistema di coaching che avresti dovuto avere
          fin dal primo giorno.
        </p>

        <div className="bg-white/10 border-2 border-white/20 rounded-2xl p-8 mb-10 shadow-2xl backdrop-blur-sm max-w-lg mx-auto" data-id="element-56">
          <p className="text-base sm:text-lg font-black mb-3 uppercase tracking-wide text-brand-gold" data-id="element-57">
            🧘 YOGA PRO™ — Box Set Completo 6 in 1 + 5 Bonus Premium
          </p>
          <div className="flex justify-center items-center gap-4 mb-2" data-id="element-58">
            <p className="text-2xl line-through text-white/50" data-id="element-59">€97</p>
            <p className="text-5xl sm:text-6xl font-black text-white" data-id="element-60">
              Solo: €27
            </p>
          </div>
        </div>

        <a href="https://yoga-pro.impultienda.ar/checkout" className="block cursor-pointer" data-id="element-61">
          <img src="https://cdn.magicpatterns.com/uploads/qeCtvuEY2ns3jiGzLBrkca/ChatGPT-Image-24-jun-2026_-10_01_02-p.m..webp" alt="YOGA PRO 6-in-1 Box Set" className="w-full max-w-[300px] mx-auto object-contain drop-shadow-2xl mb-10 hover:scale-105 transition-transform duration-500" data-id="element-62" />
        </a>

        <CTAButton href="https://yoga-pro.impultienda.ar/checkout" className="max-w-xl mx-auto mb-8" data-id="element-63">
          🚀 SÌ, VOGLIO IL MIO PACK YOGA PRO™
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm sm:text-base font-bold text-white/80" data-id="element-64">
          <div className="flex items-center gap-2" data-id="element-65">
            <Zap className="w-5 h-5 text-brand-gold" data-id="element-66" />
            <span data-id="element-67">Accesso Immediato — Consegnato Via Email</span>
          </div>
          <span className="hidden sm:inline text-white/30" data-id="element-68">•</span>
          <div className="flex items-center gap-2" data-id="element-69">
            <Star className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-70" />
            <span data-id="element-71">4.9/5 — Recensioni Professionali Verificate</span>
          </div>
          <span className="hidden sm:inline text-white/30" data-id="element-72">•</span>
          <div className="flex items-center gap-2" data-id="element-73">
            <ShieldCheck className="w-5 h-5 text-brand-green" data-id="element-74" />
            <span data-id="element-75">Garanzia 7 Giorni — Zero Rischio</span>
          </div>
        </div>
      </div>
    </section>;
}